import { useLocation } from "react-router-dom";
import Form from "../components/form";

const GetStarted = () => {
     const location = useLocation();
     const planData = location.state || {};

     return (
          <div className="getstarted">
               <h1>Get started today!</h1>
               <p>Found the perfect course for your child? Fill out the form below to get started</p>
               <Form formId="GetStarted" planData={planData} />
          </div>
     );
};

export default GetStarted;